import { render, staticRenderFns } from "./PersonDataRegistration.vue?vue&type=template&id=1389891a&scoped=true"
import script from "./PersonDataRegistration.vue?vue&type=script&lang=js"
export * from "./PersonDataRegistration.vue?vue&type=script&lang=js"
import style0 from "./PersonDataRegistration.vue?vue&type=style&index=0&id=1389891a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1389891a",
  null
  
)

export default component.exports